/** 对外展示的四支子团队 */
export const TEAM_DOMAINS = ["software", "electrical", "mechanical", "business"] as const;

export type TeamDomain = (typeof TEAM_DOMAINS)[number];

/** 队标色（对齐团队组织图） */
export const TEAM_DOMAIN_COLORS: Record<TeamDomain, string> = {
  software: "#3d9b6e",
  electrical: "#c44b4b",
  mechanical: "#d4892a",
  business: "#c45b8c",
};
